import { useMemo } from 'react'

import { HugTableContext } from './hug-table-context'

export type HugTableProviderProps = {
  /** `null` until the container's first ResizeObserver tick. */
  availableHeight: number | null
  children: React.ReactNode
}

export const HugTableProvider = ({ availableHeight, children }: HugTableProviderProps) => {
  const value = useMemo(() => ({ isInHugContainer: true, availableHeight }), [availableHeight])

  return <HugTableContext.Provider value={value}>{children}</HugTableContext.Provider>
}
